module.exports = __webpack_public_path__ + "assets/img/FormPiper-Landing-Page-+-Website.ccc1ed03.webp";